app.service('account', function() {
	
	return {
		onLoad: function (callback) { 
			callback();
		}
	};
});
